import styled from "styled-components";
import { mediaMax } from "utils/theme";

const Wrapper = styled.div`
  position: relative;

  display: flex;
  padding: 16px 24px;
  width: 100%;
  gap: 8px;
  align-items: center;
  overflow: hidden;

  border-radius: 6px;
  background: white;
  box-shadow: ${(props) => props.theme.shadows.tile};
  border: 1px solid ${(props) => props.theme.colors.danger};
  color: ${(props) => props.theme.colors.text};

  font-size: ${(props) => props.theme.fontSizesUI.md}px;
  text-decoration: none;

  &::before {
    content: "";

    position: absolute;
    left: 10px;
    top: 10px;
    bottom: 10px;

    width: 4px;

    background: ${(props) => props.theme.colors.danger};
    border-radius: 2px;
  }

  ${mediaMax("md")} {
    padding: 12px 16px;
  }
`;

const FormMessage = ({ children }) => <Wrapper>{children}</Wrapper>;

export default FormMessage;
